<div class="filter-v2">
  <div class="filter-trigger-wrap">
    <button
      type="button"
      class="filter-btn"
      [class.is-active]="menuOpen || activeFilterCount > 0"
      [attr.aria-expanded]="menuOpen"
      aria-haspopup="dialog"
      (click)="toggleMenu()"
    >
      <i-tabler name="filter" class="filter-btn-icon [&_svg]:fill-current" />
      <span>{{ 'filter' | translate }}</span>
      @if (activeFilterCount > 0) {
        <span class="filter-badge">{{ activeFilterCount }}</span>
      }
    </button>

    @if (menuOpen) {
      <button type="button" class="filter-backdrop" tabindex="-1" (click)="closeMenu()"></button>
      <div
        class="filter-panel"
        role="dialog"
        [attr.aria-label]="'filter' | translate"
        (click)="$event.stopPropagation()"
        (keydown)="onPanelKeydown($event)"
      >
        <div class="filter-header">
          <span class="filter-header-title">{{ 'filter' | translate }}</span>
          @if (activeFilterCount > 0) {
            <button type="button" class="filter-header-clear" (click)="clearAllFilters()">
              {{ 'clear all' | translate }}
            </button>
          }
        </div>

        <div class="filter-fields">
          @for (col of filterableColumns; track col.key) {
            @if (isSelectFilter(col)) {
              <div class="filter-field">
                <button
                  type="button"
                  class="filter-acc"
                  [class.is-expanded]="expandedKey === col.key"
                  [attr.aria-expanded]="expandedKey === col.key"
                  (click)="toggleField(col)"
                >
                  <span class="filter-acc-title">
                    {{ col.disableTitleTranslation ? getColumnTitle(col) : (getColumnTitle(col) | translate) }}
                  </span>
                  <span class="filter-acc-summary">
                    <span>{{ getFilterSummary(col) }}</span>
                    <i-tabler name="chevron-down" class="filter-acc-chevron" [class.is-open]="expandedKey === col.key" />
                  </span>
                </button>

                <div
                  class="filter-options-collapse"
                  [class.is-open]="expandedKey === col.key"
                  [attr.aria-hidden]="expandedKey !== col.key"
                  [attr.inert]="expandedKey === col.key ? null : ''">
                  <div class="filter-options-collapse-inner">
                    <div class="filter-optlist" role="group">
                      @for (opt of getSuggestionData(col); track opt) {
                        <div class="filter-opt-row" (click)="toggleOption(col, opt)">
                          <mat-checkbox
                            class="filter-opt"
                            [checked]="isOptionChecked(col, opt)"
                            (click)="$event.stopPropagation()"
                            (change)="onOptionChange(col, opt, $event.checked)">
                            {{ getOptionLabel(col, opt) }}
                          </mat-checkbox>
                        </div>
                      }
                      @if (!getSuggestionData(col).length) {
                        <p class="filter-empty">{{ 'no values available' | translate }}</p>
                      }
                    </div>
                  </div>
                </div>
              </div>
            } @else if (isDateFilter(col)) {
              <div class="filter-text-field">
                <label class="filter-text-label" [attr.for]="'filter-v2-' + col.key">
                  {{ col.disableTitleTranslation ? getColumnTitle(col) : (getColumnTitle(col) | translate) }}
                </label>
                <mat-form-field appearance="outline" class="filter-date-control hide-hint">
                  <input
                    matInput
                    readonly
                    [id]="'filter-v2-' + col.key"
                    [matDatepicker]="datePicker"
                    [ngModel]="filterValues[col.key] ?? null"
                    [ngModelOptions]="{ standalone: true }"
                    (dateChange)="onDateChange(col.key, $event.value)"
                    (click)="datePicker.open()" />
                  @if (filterValues[col.key]) {
                    <button
                      type="button"
                      matSuffix
                      class="filter-date-clear"
                      [attr.aria-label]="'clear' | translate"
                      (click)="clearDateFilter(col.key, $event)">
                      <i-tabler name="x" />
                    </button>
                  }
                  <mat-datepicker-toggle matIconSuffix [for]="datePicker" />
                  <mat-datepicker #datePicker />
                </mat-form-field>
              </div>
            } @else {
              <div class="filter-text-field">
                <label class="filter-text-label" [attr.for]="'filter-v2-' + col.key">
                  {{ col.disableTitleTranslation ? getColumnTitle(col) : (getColumnTitle(col) | translate) }}
                </label>
                <span class="filter-text-control">
                  <i-tabler name="search" class="filter-text-icon" />
                  <input
                    class="filter-text-input"
                    type="text"
                    [id]="'filter-v2-' + col.key"
                    [ngModel]="textDrafts[col.key] || ''"
                    [ngModelOptions]="{ standalone: true }"
                    [placeholder]="'search' | translate"
                    (ngModelChange)="onTextDraftChange(col.key, $event)"
                    (keyup.enter)="onTextEnter(col.key)"
                    (blur)="onTextBlur(col.key)"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                  />
                  @if (textDrafts[col.key]) {
                    <button
                      type="button"
                      class="filter-text-clear"
                      [attr.aria-label]="'clear' | translate"
                      (mousedown)="$event.preventDefault()"
                      (click)="clearTextFilter(col.key, $event)">
                      <i-tabler name="x" />
                    </button>
                  }
                </span>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>

  @if (filterChips.length) {
    <div class="filter-chips" role="list" [attr.aria-label]="'filter' | translate">
      @for (chip of visibleFilterChips; track chip.key + '-' + chip.value) {
        <span class="filter-chip" role="listitem" [title]="chip.label">
          <span class="chip-text">{{ chip.label }}</span>
          <button type="button" class="chip-remove" (click)="removeFilterByKey(chip.key, chip.value)">
            <i-tabler name="x" />
          </button>
        </span>
      }
      @if (hiddenFilterChipCount > 0) {
        <div
          class="filter-overflow-wrap"
          (mouseenter)="openOverflow()"
          (mouseleave)="scheduleOverflowClose()">
          <button
            type="button"
            class="filter-overflow-btn"
            [class.is-open]="overflowOpen"
            [attr.aria-expanded]="overflowOpen"
            aria-haspopup="dialog"
            [attr.aria-label]="'+' + hiddenFilterChipCount"
            (click)="openOverflow()">
            +{{ hiddenFilterChipCount }}
          </button>

          @if (overflowOpen) {
            <section
              class="filter-overflow-panel"
              role="dialog"
              [attr.aria-label]="'additional filters' | translate"
              (mouseenter)="openOverflow()"
              (mouseleave)="scheduleOverflowClose()">
              <header class="filter-overflow-header">
                <span>{{ 'additional filters' | translate }}</span>
                <span class="filter-overflow-count">{{ hiddenFilterChipCount }}</span>
                <button type="button" class="filter-overflow-close" (click)="closeOverflow()">
                  <i-tabler name="x" />
                </button>
              </header>

              <div class="filter-overflow-content">
                @for (group of hiddenFilterGroups; track group.key) {
                  <div class="filter-overflow-group">
                    <div class="filter-overflow-group-header">
                      <span>{{ group.title }}</span>
                      <span>{{ 'n selected' | translate: { count: group.chips.length } }}</span>
                    </div>
                    <div class="filter-overflow-items">
                      @for (chip of group.chips; track chip.key + '-' + chip.value) {
                        <div class="filter-overflow-item">
                          <span class="filter-overflow-dot"></span>
                          <span class="filter-overflow-value" [title]="chip.displayValue">{{ chip.displayValue }}</span>
                          <button type="button" (click)="removeHiddenFilter(chip.key, chip.value)">
                            <i-tabler name="x" />
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>

              <footer class="filter-overflow-footer">
                <button type="button" (click)="clearHiddenFilters()">{{ 'clear these filters' | translate }}</button>
                <button type="button" (click)="viewAllFilters()">
                  <span>{{ 'view all filters' | translate }}</span>
                  <i-tabler name="arrow-right" />
                </button>
              </footer>
            </section>
          }
        </div>
      }
      <button type="button" class="clear-all-btn" (click)="clearAllFilters()">{{ 'clear all' | translate }}</button>
    </div>
  }
</div>
